import PropTypes from 'prop-types';
import { Link, useSearchParams } from 'react-router-dom';

import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import { useIntl } from '@zenbusiness/application-commons-intl';
import Filter from '@zenbusiness/zui/Filter';
import Skeleton from '@zenbusiness/zui/Skeleton';

import { DEFAULT_CATEGORY_FILTER, PRODUCTS_FILTER_PARAM_KEY } from '#client/pages/Products/constants';
import { formatSearchParams } from '#client/utils/formatString';

function ProductCardsFilter({ items, loading }) {
  const [searchParams] = useSearchParams();
  const categoryFilter = searchParams.get(PRODUCTS_FILTER_PARAM_KEY) || DEFAULT_CATEGORY_FILTER;
  const { formatMessage: fm } = useIntl();

  const handleFilterClickTracking = useLinkPressedCallback({
    elementName: 'category_filter',
  });

  const itemsWithAll = [
    {
      titleKey: 'products.category.all.label',
      uuid: DEFAULT_CATEGORY_FILTER,
    },
    ...items,
  ];

  if (loading) {
    return <Skeleton height={36} variant="rounded" />;
  }

  return (
    <Filter onChange={handleFilterClickTracking} value={categoryFilter}>
      {itemsWithAll.map(({ titleKey, uuid }) => {
        const label = fm({ id: titleKey });

        return (
          <Filter.Item
            component={Link}
            key={uuid}
            label={label}
            to={uuid === DEFAULT_CATEGORY_FILTER ? '' : `?${PRODUCTS_FILTER_PARAM_KEY}=${formatSearchParams(label)}`}
            value={formatSearchParams(label)}
          />
        );
      })}
    </Filter>
  );
}

ProductCardsFilter.propTypes = {
  loading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      titleKey: PropTypes.string,
      uuid: PropTypes.string,
    }),
  ).isRequired,
};

export default ProductCardsFilter;
